var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "12px",
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u05D7\u05E5 \u05E1\u05D5\u05E8\u05D8 \u05E9\u05E0\u05D9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u05D2\\u05D9\\u05E8\\u05E1\\u05D4-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D4\\u05D6\\u05DE\\u05E0\\u05D4-copy",
    transform: "translate(-858.000000, -313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D7\\u05E5-\\u05E1\\u05D5\\u05E8\\u05D8-\\u05E9\\u05E0\\u05D9",
    transform: "translate(862.000000, 319.000000) rotate(-270.000000) translate(-862.000000, -319.000000) translate(854.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0091FF",
    fillRule: "nonzero",
    points: "14 7.33333333 4.55333333 7.33333333 6.94 4.94 6 4 2 8 6 12 6.94 11.06 4.55333333 8.66666667 14 8.66666667"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow_1.602d86f5b82e08df3c6b11c76c471e13.svg";
export { ForwardRef as ReactComponent };